import axios from './../plugins/private-api-axios'

export const requestSnapshotService = {
    urlPrefix: '/snapshotsRequests',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async requestSnapshot (vehicleId, type) {
        try {
            return await axios.post(this.urlPrefix, {
                id: vehicleId,
                type: type
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async getSnapshotsRequests (fleetId, vehicleId) {
        try {
            let urlBuilder = {}

            if (vehicleId) {
                urlBuilder.VehicleId = vehicleId
            }

            if (fleetId) {
                urlBuilder.FleetId = fleetId
            }

            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async requestVideo (vehicleId, startDate, endDate) {
        try {
            return await axios.post(`${this.urlPrefix}/video`, {
                id: vehicleId,
                startDateTime: startDate,
                endDateTime: endDate,
                overlayFlag: true,
                channelId: 99
            }, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateRequestSnapshotService = (accessToken) => {
    requestSnapshotService.config.headers.Authorization = accessToken
}

export default requestSnapshotService
